import { MessageCircle } from "lucide-react";

const WHATSAPP_NUMBER = "919920261283"; // +91 9920261283 (no '+', no spaces)
const DEFAULT_MESSAGE =
  "Hi Bon Evento, I'd love to plan my celebration with you. Could we connect?";

export const buildWhatsAppUrl = (message = DEFAULT_MESSAGE) =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;

const WhatsAppButton = () => {
  return (
    <a
      href={buildWhatsAppUrl()}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="floating-whatsapp-btn"
      aria-label="Chat with Bon Evento on WhatsApp"
      className="group fixed bottom-20 right-5 md:bottom-24 md:right-7 z-[60] inline-flex items-center"
    >
      {/* Pulse ring */}
      <span
        aria-hidden
        className="absolute inset-0 rounded-full bg-[#B8935C]/30 animate-ping"
        style={{ animationDuration: "2.4s" }}
      />

      {/* Pill that expands on hover (desktop) */}
      <span className="relative inline-flex items-center gap-3 h-14 md:h-15 pl-4 pr-5 rounded-full bg-[#121623] border border-[#B8935C]/50 shadow-[0_10px_40px_-10px_rgba(184,147,92,0.6)] hover:border-[#B8935C] transition-all duration-500">
        <span className="inline-flex items-center justify-center w-10 h-10 rounded-full bg-[#B8935C] text-[#080B12] group-hover:bg-[#D4AF37] transition-colors">
          <MessageCircle size={18} strokeWidth={1.8} />
        </span>
        <span className="hidden md:inline overline text-[10px] tracking-[0.24em] text-[#F0EBE1] group-hover:text-[#B8935C] transition-colors whitespace-nowrap">
          Chat&nbsp;on&nbsp;WhatsApp
        </span>
      </span>
    </a>
  );
};

export default WhatsAppButton;
